import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import type { StyleValue } from "../../../StyleValue.types";
import { HomepageBlock4 } from "../../Homepage/HomepageBlock4/HomepageBlock4";

export interface TestimonialsBlock3Props extends ComponentPropsWithRef<"div"> {
  content?: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const TestimonialsBlock3 = forwardRef<
  HTMLDivElement,
  TestimonialsBlock3Props
>(({ ...rest }, ref) => (
  <HomepageBlock4
    backgroundBlockClassName="wb-bg-secondary"
    ref={ref}
    {...rest}
  />
));

TestimonialsBlock3.displayName = "TestimonialsBlock3";
